import React from "react";
import InputColor from "./InputColor";
import MultiOptionsInput from "./MultiOptionsInput";

const ColorSelectorPress = ({
  pressStorefrontMainColor = "",
  pressStorefrontSecondaryTextColor = "white",
  onChange = () => {},
  onChangeColor = () => {},
}) => {
  return (
    <div className="color-selector">
      <div className="color-container">
        <div className="color-picker-container mt-6">
          <label>Storefront Main Color</label>
          <InputColor
            inputName="pressStorefrontMainColor"
            inputNameColor="pressStorefrontMainColorPicker"
            value={pressStorefrontMainColor}
            onChange={onChangeColor}
          />
        </div>
        <div className="color-picker-container mt-6">
          <label>Storefront secondary color (Text)</label>
          <MultiOptionsInput
            value={pressStorefrontSecondaryTextColor}
            onChange={onChange}
            options={["white", "black"]}
            inputName="pressStorefrontSecondaryTextColor"
          />
        </div>
      </div>
    </div>
  );
};

export default ColorSelectorPress;

// import React from "react";
// import InputColor from "./InputColor";
// import MultiOptionsInput from "./MultiOptionsInput";

// const ColorSelector = ({
//   storefrontMainColor = "",
//   pressStorefrontMainColor = "",
//   storefrontSecondaryTextColor = "white",
//   pressStorefrontSecondaryTextColor = "white",
//   onChange = () => {},
//   onChangeColor = () => {},
// }) => {
//   return (
//     <div className="color-selector">
//       <div className="label">Storefront Color</div>
//       <div className="color-container">
//         <div className="color-picker-container">
//           <div className="label req">Storefront Main Color</div>
//           <InputColor
//             inputName={pressStorefrontMainColor ? "pressStorefrontMainColor" : "storefrontMainColor"}
//             inputNameColor={pressStorefrontMainColor ? "pressStorefrontMainColorPicker" :"storefrontMainColorPicker"}
//             value={pressStorefrontMainColor ? pressStorefrontMainColor : storefrontMainColor}
//             onChange={onChangeColor}
//           />
//         </div>
//         <div className="color-picker-container">
//           <div className="label req">Storefront secondary color (Text)</div>
//           <MultiOptionsInput
//             value={pressStorefrontSecondaryTextColor ? pressStorefrontSecondaryTextColor : storefrontSecondaryTextColor}
//             onChange={onChange}
//             options={["white", "black"]}
//             inputName={pressStorefrontSecondaryTextColor ? "pressStorefrontSecondaryTextColor" : "storefrontSecondaryTextColor"}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ColorSelector;
